import { useConfigurator } from '@/app/store/configurator/hooks/use-configurator';
import { getSectionParams } from '@/shared/lib/section';
import { useTranslation } from 'react-i18next';
import { SectionInfo } from '../section-info/section-info';
import styles from './sections-info.module.css';

export const SectionsInfo = () => {
	const { t } = useTranslation();
	const {
		state: { sections },
	} = useConfigurator();

	return (
		<div className={styles.wrapper}>
			<p className={styles.title}>{t('sectionParams.title')}</p>
			<div className={styles.sections}>
				{sections.map((section, index) => (
					<SectionInfo
						title={`${t('sectionParams.sectionUnit')} ${index + 1}`}
						params={getSectionParams(section)}
						key={index}
					/>
				))}
			</div>
		</div>
	);
};
